// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__bvvaj","field":"styles_field__1X4BB","fieldCol":"styles_fieldCol__1T0ij","diffCol":"styles_diffCol__2FgST","diff":"styles_diff__1Wesr"};